import { previewUrl } from '@theme/excello-preview';
import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';
let loadCard, loadCollection, classify, selectRelated, sameGender, interleave, parallelMap;
let wishlistModules;
async function prepareWishlist(){
 if(!wishlistModules)wishlistModules=Promise.all([import('@theme/excello-journey'),import('@theme/excello-match'),import('@theme/excello-family')]).then(([journey,match,family])=>{({loadCard,loadCollection}=journey);({classify,selectRelated,sameGender}=match);({interleave,parallelMap}=family);});
 return wishlistModules;
}
const scope=document.querySelector('[data-excello-shopper]')?.dataset.excelloShopper||'guest';
const key=`excello-wishlist-v1:${scope}`;
const temporary=new Map();
const dialog=document.querySelector('#excello-wishlist-dialog');
const words=document.querySelector('[data-shopper-copy]')?.content;
const label=name=>words?.querySelector(`[data-${name}]`)?.textContent||'';
const allowed=()=>window.Shopify?.customerPrivacy?.preferencesProcessingAllowed?.()===true;
function read(){try{return (allowed()?JSON.parse(localStorage.getItem(key)||sessionStorage.getItem(key)||'[]'):JSON.parse(sessionStorage.getItem(key)||'[]')).filter(x=>/^[a-z0-9-]+$/.test(x));}catch{return temporary.get(key)||[];}}
function save(items){temporary.set(key,items);try{sessionStorage.setItem(key,JSON.stringify(items));}catch{}if(allowed())try{localStorage.setItem(key,JSON.stringify(items));}catch{}}
function update(){
 const items=read(),selectedHandles=new Set(items),addLabel=label('add'),removeLabel=label('remove');
 for(const button of document.querySelectorAll('[data-wishlist-toggle]')){
  const selected=selectedHandles.has(button.dataset.handle),pressed=String(selected),copy=selected?removeLabel:addLabel;
  if(button.getAttribute('aria-pressed')!==pressed)button.setAttribute('aria-pressed',pressed);
  const title=button.querySelector('[data-wishlist-label]');if(title&&title.textContent!==copy)title.textContent=copy;
  const heart=button.querySelector('[aria-hidden]');
  if(heart?.hasAttribute('data-wishlist-heart')){if(button.getAttribute('aria-label')!==copy)button.setAttribute('aria-label',copy);}
  else if(heart){const icon=selected?'♥':'♡';if(heart.textContent!==icon)heart.textContent=icon;}
 }
 for(const button of document.querySelectorAll('[data-wishlist-open]')){
  const count=button.querySelector('[data-wishlist-count]');if(!count)continue;
  if(count.textContent!==String(items.length))count.textContent=String(items.length);
  count.hidden=items.length===0;button.dataset.wishlistBaseLabel||=button.getAttribute('aria-label')||label('wishlist');
  const copy=button.dataset.wishlistBaseLabel+(items.length?' ('+items.length+')':'');
  if(button.getAttribute('aria-label')!==copy)button.setAttribute('aria-label',copy);
 }
}
// Cart state is confirmed from Shopify, never persisted as a Wishlist flag.
let wishlistCartItems=[];
let cartRevision=0;
function syncWishlistCart(){
 for(const row of dialog?.querySelectorAll('[data-wishlist-handle]')||[]){
  const button=row.querySelector('[data-wishlist-cart]'),form=row.querySelector('[data-wishlist-form]');
  if(!button.dataset.originalLabel){button.dataset.originalLabel=button.textContent;button.dataset.unavailable=String(button.disabled);}
  const inCart=wishlistCartItems.some(item=>String(item.product_id)===row.dataset.productId&&item.quantity>0);
  button.dataset.inCart=String(inCart);button.textContent=inCart?label('in-cart'):button.dataset.originalLabel;
  button.disabled=inCart||button.dataset.unavailable==='true'||!!form.dataset.busy;
  form.querySelector('[type=submit]').disabled=inCart||!!form.dataset.busy;
  if(inCart){form.hidden=true;button.setAttribute('aria-expanded','false');}
 }
}
async function refreshWishlistCart(){
 const revision=++cartRevision,root=window.Shopify?.routes?.root||'/';
 const response=await fetch(`${root}cart.js`,{credentials:'same-origin',cache:'no-store'});
 if(!response.ok)throw new Error(label('cart-error'));
 const cart=await response.json();
 if(revision===cartRevision){wishlistCartItems=cart.items||[];syncWishlistCart();}
 return cart;
}
function safeBrowse(raw){
 try{const url=new URL(raw,location.origin),root=window.Shopify?.routes?.root||'/';
  return url.origin===location.origin&&url.pathname.startsWith(`${root}collections/`)?url.pathname+url.search:null;
 }catch{return null;}
}
function wishlistExplore(){
 const link=dialog?.querySelector('[data-wishlist-explore]');if(!link)return;
 const current=safeBrowse(location.href)||safeBrowse(document.referrer);
 let previous;try{if(current)sessionStorage.setItem('excello-wishlist-browse-v1',current);previous=sessionStorage.getItem('excello-wishlist-browse-v1');}catch{}
 const destination=current||safeBrowse(previous);
 if(destination)link.href=previewUrl(destination).toString();
}
wishlistExplore();
function refreshOpenWishlist(){if(dialog?.open)refreshWishlistCart().catch(()=>{});}
document.addEventListener(StandardEvents.cartLinesUpdate,event=>{Promise.resolve(event.promise).then(refreshOpenWishlist,refreshOpenWishlist);});
window.addEventListener('pageshow',refreshOpenWishlist);
window.addEventListener('focus',refreshOpenWishlist);
document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='visible')refreshOpenWishlist();});
let wishlistRun=0;
let wishlistSeeds=[];
function wishlistState(){
 const populated=read().length>0;
 dialog.querySelector('[data-wishlist-empty]').hidden=populated;
 dialog.querySelector('[data-wishlist-footer]').hidden=!populated;
 if(!populated){dialog.querySelector('[data-wishlist-status]').textContent=label('empty');dialog.querySelector('[data-wishlist-suggestions]').replaceChildren();dialog.querySelector('[data-wishlist-suggestions]').hidden=true;}
}
async function wishlistRow(handle){
 const root=window.Shopify?.routes?.root||'/';
 const url=previewUrl(`${root}products/${handle}`);
 url.searchParams.set('section_id','excello-wishlist-row');
 const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
 const response=await fetch(url,{credentials:'same-origin'});if(!response.ok)throw new Error('Wishlist row unavailable');
 const doc=new DOMParser().parseFromString(await response.text(),'text/html');
 const template=doc.querySelector('[data-wishlist-row]'),data=doc.querySelector('[data-wishlist-product]');
 return template&&data?{node:template.content.firstElementChild,item:classify(JSON.parse(data.textContent))}:null;
}
async function wishlistSuggestions(run){
 const list=dialog.querySelector('[data-wishlist-suggestions]');list.replaceChildren();list.hidden=true;
 const seeds=wishlistSeeds.filter(item=>read().includes(item.handle)&&item.gender);
 if(!seeds.length)return;
 const pool=await loadCollection('all').catch(()=>[]);
 if(run!==wishlistRun||!dialog.open)return;
 const omitted=new Set(read()),rankings=seeds.map(item=>selectRelated(item,pool,new Set(),pool.length)),candidates=[];
 for(let index=0;candidates.length<pool.length&&rankings.some(items=>index<items.length);index++){
  for(const items of rankings){const item=items[index];if(item&&!omitted.has(item.handle)){candidates.push(item);omitted.add(item.handle);}}
 }
 const selected=interleave(candidates).slice(0,8);
 const results=await parallelMap(selected,item=>loadCard(item.handle).catch(()=>null),4);
 for(let index=0;index<selected.length;index++){
  const item=selected[index],result=results[index];
  if(run!==wishlistRun||!dialog.open)return;
  if(!result||read().includes(item.handle)||!seeds.some(seed=>sameGender(seed,classify(result.item))))continue;
  const li=document.createElement('li');li.dataset.productId=String(item.id);li.dataset.gender=item.gender;li.innerHTML=result.html;list.append(li);list.hidden=false;
 }
}
async function show(){
 if(!dialog.open)dialog.showModal();wishlistExplore();const run=++wishlistRun;
 const cartReady=refreshWishlistCart().catch(()=>null);
 const list=dialog.querySelector('[data-wishlist-list]'),status=dialog.querySelector('[data-wishlist-status]');
 list.replaceChildren();wishlistSeeds=[];dialog.querySelector('[data-wishlist-suggestions]').replaceChildren();dialog.querySelector('[data-wishlist-suggestions]').hidden=true;
 wishlistState();if(!read().length)return;status.textContent=label('loading');let failures=0;
 await prepareWishlist();
 const handles=read(),results=await parallelMap(handles,handle=>wishlistRow(handle).catch(()=>null),4);
 for(let index=0;index<handles.length;index++){
  const handle=handles[index],result=results[index];
  if(run!==wishlistRun||!dialog.open)return;
  if(!read().includes(handle))continue;
  if(!result){failures++;continue;}
  list.append(result.node);wishlistSeeds.push(result.item);syncWishlistCart();
 }
 await cartReady;if(run!==wishlistRun||!dialog.open)return;
 status.textContent=failures?label('wishlist-error'):'';wishlistState();update();await wishlistSuggestions(run);
}
async function wishlistCart(form){
 if(!form.reportValidity()||form.dataset.busy)return;
 const row=form.closest('[data-wishlist-handle]'),status=row.querySelector('[data-wishlist-row-status]');
 const variant=form.elements.id.value;if(!variant)return;
 form.dataset.busy='true';syncWishlistCart();status.textContent=label('loading');
 let deferred;
 try{
  const before=await refreshWishlistCart();
  if(before.items.some(item=>String(item.product_id)===row.dataset.productId&&item.quantity>0)){status.textContent='';return;}
  deferred=CartLinesUpdateEvent.createPromise();
  deferred.promise.catch(()=>{});
  row.dispatchEvent(new CartLinesUpdateEvent({action:'add',context:'product',lines:[{merchandiseId:variant,quantity:1}],promise:deferred.promise}));
  const data=new FormData(form);data.set('quantity','1');
  const sectionIds=[...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(node=>node.dataset.sectionId))];
  if(sectionIds.length)data.set('sections',sectionIds.slice(0,5).join(','));data.set('sections_url',location.pathname);
  const root=window.Shopify?.routes?.root||'/';
  const response=await fetch(`${root}cart/add.js`,{method:'POST',body:data,credentials:'same-origin'}),result=await response.json();
  if(!response.ok||result.status)throw new Error(result.description||label('cart-error'));
  const added=result.items||[result],items=[...before.items];
  for(const item of added){const index=items.findIndex(line=>line.key===item.key);if(index<0)items.push(item);else items[index]=item;}
  ++cartRevision;wishlistCartItems=items;syncWishlistCart();
  // A successful add stays completed even if the follow-up read is interrupted.
  const cart=await refreshWishlistCart().catch(()=>({...before,items,item_count:items.reduce((total,item)=>total+item.quantity,0)}));
  deferred.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{items:cart.items,source:'product-form-component',sourceId:`wishlist-${form.dataset.productId}`,itemCount:1,productId:form.dataset.productId,sections:result.sections,didError:false}});
  status.textContent=label('added');form.hidden=true;row.querySelector('[data-wishlist-cart]').setAttribute('aria-expanded','false');
 }catch(error){deferred?.reject(error);status.textContent=error.message||label('cart-error');}
 finally{delete form.dataset.busy;syncWishlistCart();}
}
document.addEventListener('submit',event=>{if(event.target.matches('[data-wishlist-form]')){event.preventDefault();wishlistCart(event.target);}});
dialog?.addEventListener('close',()=>{wishlistRun++;});
document.addEventListener('click',async event=>{const button=event.target.closest('button');if(!button)return;if(button.matches('[data-wishlist-toggle]')){const items=read(),handle=button.dataset.handle;save(items.includes(handle)?items.filter(x=>x!==handle):[handle,...items]);update();if(dialog.open){if(!read().includes(handle))dialog.querySelector(`[data-wishlist-handle="${handle}"]`)?.remove();dialog.querySelector('[data-wishlist-status]').textContent='';wishlistState();wishlistSuggestions(++wishlistRun);}}else if(button.matches('[data-wishlist-open]'))await show();else if(button.matches('[data-wishlist-close]'))dialog.close();else if(button.matches('[data-wishlist-cart]')){if(button.disabled||button.dataset.inCart==='true')return;const form=button.closest('[data-wishlist-handle]').querySelector('[data-wishlist-form]');if(form.querySelector('select')){form.hidden=!form.hidden;button.setAttribute('aria-expanded',String(!form.hidden));if(!form.hidden)form.querySelector('select').focus();}else wishlistCart(form);}});
function setup(){const template=document.querySelector('[data-product-tools]');if(template&&!document.querySelector('.excello-product-tools')){const target=document.querySelector('media-gallery');if(target)target.append(template.content.cloneNode(true));}update();}
setup();document.addEventListener('shopify:section:load',setup);window.addEventListener('storage',update);document.addEventListener('visitorConsentCollected',()=>{if(allowed())save([...new Set([...read(),...(temporary.get(key)||[])])]);else try{localStorage.removeItem(key);}catch{}update();});

const reviewRoot=document.querySelector('.excello-reviews');if(reviewRoot){const rename=()=>{for(const title of reviewRoot.querySelectorAll('.jdgm-rev-widg__title'))if(title.textContent!==reviewRoot.querySelector('summary').textContent)title.textContent=reviewRoot.querySelector('summary').textContent;};new MutationObserver(rename).observe(reviewRoot,{childList:true,subtree:true});rename();}

if(!window.Shopify?.customerPrivacy)window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)update();});

function preservePreviewLinks(root=document) {
  if(!location.hostname.endsWith('.myshopify.com') || new URL(location.href).searchParams.get('_fd')!=='0')return;
  for(const link of root.querySelectorAll('a[href]')) {
    const raw=link.getAttribute('href');
    if(!raw || raw.startsWith('#') || !/^https?:|^\//.test(raw))continue;
    const url=previewUrl(raw);
    if(url.origin===location.origin)link.setAttribute('href',url.pathname+url.search+url.hash);
  }
}
preservePreviewLinks();
const pendingShopperRoots=new Set();
let shopperFrame=0;
new MutationObserver(records=>{
 for(const record of records)for(const node of record.addedNodes)if(node.nodeType===1)pendingShopperRoots.add(node);
 if(!pendingShopperRoots.size||shopperFrame)return;
 shopperFrame=requestAnimationFrame(()=>{
  shopperFrame=0;let galleryAdded=false;
  for(const node of pendingShopperRoots){
   if(!node.isConnected)continue;
   if(node.matches('a[href]'))preservePreviewLinks(node.parentElement);
   else preservePreviewLinks(node);
   if(!galleryAdded&&(node.matches('media-gallery')||node.querySelector('media-gallery')))galleryAdded=true;
  }
  pendingShopperRoots.clear();if(galleryAdded)setup();
 });
}).observe(document.body,{childList:true,subtree:true});
document.addEventListener('click',event=>{
  const link=event.target.closest('a[href]');
  if(link)preservePreviewLinks(link.parentElement||document);
},true);




